/* InvitationsStatsCard — bovenaan dashboard voor super-admin.
 * Toont totalen per status + snelle "opschonen"-actie voor verlopen items.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MailPlus, Clock, CheckCircle2, XOctagon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function InvitationsStatsCard() {
  const [stats, setStats] = useState(null);
  const nav = useNavigate();

  const load = async () => {
    try {
      const r = await api.get("/invitations/stats");
      setStats(r.data);
    } catch { /* niet super-admin — component blijft leeg */ }
  };
  useEffect(() => { load(); }, []);

  if (!stats) return null;

  const tiles = [
    { key: "open", label: "Open uitnodigingen", val: stats.open, icon: Clock, tone: "text-sky-700 bg-sky-50 border-sky-200" },
    { key: "verlopen", label: "Verlopen", val: stats.verlopen, icon: XOctagon, tone: "text-red-700 bg-red-50 border-red-200" },
    { key: "goedgekeurd", label: "Goedgekeurd", val: stats.goedgekeurd, icon: CheckCircle2, tone: "text-emerald-700 bg-emerald-50 border-emerald-200" },
    { key: "concept", label: "Concept (niet verstuurd)", val: stats.concept, icon: MailPlus, tone: "text-amber-700 bg-amber-50 border-amber-200" },
  ];

  return (
    <Card className="p-4 mb-4 border" data-testid="invitations-stats-card">
      <div className="flex items-center gap-2 mb-3">
        <MailPlus className="h-4 w-4 text-slate-600" />
        <h3 className="font-semibold text-sm">Onboarding uitnodigingen</h3>
        <span className="text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 border border-slate-200">
          Overzicht · {stats.totaal} totaal
        </span>
        <div className="ml-auto flex gap-2">
          {stats.verlopen > 0 && (
            <Button size="sm" variant="ghost"
                    onClick={() => nav("/app/uitnodigingen?status=verlopen")}
                    data-testid="inv-stats-cleanup"
                    className="h-7 text-red-600 hover:bg-red-50">
              Ruim verlopen op
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={() => nav("/app/uitnodigingen")}
                  data-testid="inv-stats-open"
                  className="h-7">
            Beheren →
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {tiles.map((t) => (
          <div key={t.key}
               className={`border rounded p-2.5 ${t.tone}`}
               data-testid={`inv-stat-${t.key}`}>
            <div className="flex items-center gap-1.5">
              <t.icon className="h-3.5 w-3.5" />
              <span className="text-[10px] uppercase tracking-wider">{t.label}</span>
            </div>
            <div className="text-2xl font-bold tabular-nums mt-1">{t.val}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
